import { Card, Grid, lighten, styled, Typography } from "@mui/material";

export const CardWrapper = styled(Grid)({
  padding: "5px",
});

export const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.background.default,
  borderRadius: "5px",
}));

export const EmployeeDataContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "15px",
});

export const NameContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  // gap:"5px"
});

export const Email = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.light,
}));

export const PhoneNumber = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.light,
}));

export const DateContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  padding: "15px",
  justifyContent: "center",
  // alignContent:"center",
  "& .MuiTypography-root:first-of-type": {
    color: theme.palette.secondary.light,
  },
}));

export const ApproverContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: lighten(theme.palette.primary.light, 0.5),
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  justifyContent: "center",
  alignItems: "center",
  "& .MuiTypography-root:first-of-type": {
    color: theme.palette.secondary.light,
  },
  "& .MuiTypography-root:nth-of-type(n+2)": {
    color: theme.palette.primary.main,
  },
  maxWidth: "300px",
  padding: "12px 0",
  boxSizing: "border-box",
}));
